import React, { useState, useEffect, useRef } from 'react';
import each from 'lodash-es/each';
import max from 'lodash-es/max';
import find from 'lodash-es/find';
import Flickity from 'react-flickity-component';
import 'flickity-imagesloaded';
import AdMindClick from '../../components/AdMind/click';
import ProductTileAlternate from '../../components/React/ProductTileAlternate.jsx';
import SliderCartPromoTile from '../../components/React/SliderCartPromoTile.jsx';
import {
  getGraphIDFromProductId,
  getShopifyProductsForCountry,
} from '../../utils/retrieveShopifyProductsForSelectedCountry';

const hideShowRecommendedHeader = () => {
  try {
    if (window.cart.item_count > 0) {
      document.querySelectorAll('[data-cart-header-not-empty]').forEach((el) => (el.style.display = 'block'));
      document.querySelectorAll('[data-cart-header-empty]').forEach((el) => (el.style.display = 'none'));
    } else {
      document.querySelectorAll('[data-cart-header-not-empty]').forEach((el) => (el.style.display = 'none'));
      document.querySelectorAll('[data-cart-header-empty]').forEach((el) => (el.style.display = 'block'));
    }
  } catch (error) {
    console.log(error);
  }
};

const handleCartDidUpdate = () => {
  hideShowRecommendedHeader();
};

const SliderCartAddons = (props) => {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('');
  const [variantAvailabilities, setVariantAvailabilities] = useState([]);
  const flickity = useRef(null);
  let updatedItems = [];

  let length = items.length;
  let cellAlign = 'right';
  let showButtons = true;

  // Optimizely test
  if (window.innerWidth > 767) {
    length = 0;
    cellAlign = 'left';
  }

  if (window.innerWidth > 1116 && items.length < 5) {
    showButtons = false;
  }

  const carouselOptions = {
    imagesLoaded: true,
    cellAlign,
    contain: true,
    draggable: true,
    dragThreshold: 3,
    initialIndex: length,
    prevNextButtons: showButtons,
  };

  const handleCertonaRecommendationsDidLoad = async () => {
    if (!window.certonaSchemes) {
      return;
    }

    hideShowRecommendedHeader();

    let recItems = '';

    if (window.certonaSchemes && window.certonaSchemes.cart1_rr) {
      recItems = window.certonaSchemes.cart1_rr;
    } else if (window.certonaSchemes && window.certonaSchemes.emptycart1_rr) {
      recItems = window.certonaSchemes.emptycart1_rr;
    } else {
      return;
    }

    const filteredRecItems = recItems.filter((item) => {
      return item.Child_Attributes.length > 0;
    });

    const graphProductIds = filteredRecItems.map((item) => {
      return getGraphIDFromProductId(item.product_id);
    });

    try {
      const shopify_products = await getShopifyProductsForCountry(graphProductIds);

      const availabilities = {};

      const final_items_list = [];
      each(shopify_products, (product) => {
        if (!product.variants) {
          console.error(`No variants found in Shopify for this product: ${product.id}`);
          return;
        }
        const product_id_parts = product.id.split('/');
        const product_id = product_id_parts[product_id_parts.length - 1];
        const certona_product = find(filteredRecItems, { product_id });
        if (!certona_product) {
          return;
        }
        each(product.variants, (variant) => {
          const variant_id_parts = variant.id.split('/');
          const variant_id = variant_id_parts[variant_id_parts.length - 1];
          availabilities[variant_id] = variant.availableForSale;
          const certona_variant = find(certona_product.Child_Attributes, { variant_id });
          if (!certona_variant) {
            return;
          }
          certona_variant.compare_at_price = Number(variant.compareAtPrice.amount).toFixed(2);
          certona_variant.price = Number(variant.price.amount).toFixed(2);
        });
        final_items_list.push(certona_product);
      });
      if (final_items_list.length === 0) {
        document.querySelector('.SliderCartAddOns').style.display = 'none';
      }

      setVariantAvailabilities(availabilities);
      setItems(final_items_list);
      updatedItems = final_items_list;

      window.dispatchEvent(new window.Event('resize'));
    } catch (error) {
      console.log('!!! SliderCartAddons unable to fetch product data', error);
    }
  };

  const handleLoad = (event) => {
    setItems(event.detail.monetateData);
    setTitle(event.detail.title);
  };

  useEffect(() => {
    document.addEventListener('monetateLoadedcart1_rr', handleLoad);
    document.addEventListener('monetateLoadedemptycart1_rr', handleLoad);

    return () => {
      document.removeEventListener('monetateLoadedcart1_rr', handleLoad);
      document.removeEventListener('monetateLoadedemptycart1_rr', handleLoad);
    };
  }, []);

  return (
    <div>
      {title && title.trim() && (
        <div className="SliderCartAddOns__headings">
          <h2>{title}</h2>
        </div>
      )}
      {items && items.length > 0 && (
        <Flickity className="SliderCartAddons" options={carouselOptions} reloadOnUpdate={true} ref={flickity}>
          {items.map((item, i) => {
            if (!item.Child_Attributes) {
              return null;
            }

            const firstVariant = item.Child_Attributes[0];
            const comparePrices = item.Child_Attributes.map((variant) => {
              return variant.compare_at_price;
            });
            const comparePriceMax = max(comparePrices);

            const variantsWithAvailability = item.Child_Attributes.map((variant) => {
              const available = variantAvailabilities[variant.variant_id]
                ? variantAvailabilities[variant.variant_id]
                : false;

              return {
                ...variant,
                available,
              };
            });

            const productUrl = item.Detail_URL.replace('https://windsor-us.myshopify.com', '');

            return (
              <ProductTileAlternate
                key={`TrendingCarousel__ProductTile-${item.ID}-${i}`}
                id={item.item_group_id}
                pid={item.ID}
                title={item.Title}
                product_url={productUrl}
                thumb_url={firstVariant.image_url}
                thumb_alt={item.Title}
                price={firstVariant.price}
                price_compare={firstVariant.compare_at_price}
                price_compare_max={comparePriceMax}
                tags={item.tags.split(',')}
                variants={variantsWithAvailability}
                product={item}
                options={item.options}
                colorOptions={item.color}
                sizeOptions={item.size}
                isRec={true}
                selectedColor={item.selectedColor}
              />
            );
          })}
          {/* Optmizely test */}
          {window.innerWidth < 767 && <SliderCartPromoTile promo={props.promo} />}
        </Flickity>
      )}
    </div>
  );
};

export default SliderCartAddons;
